const RESPONSE_TIMEOUT_MS = 2500;

export const buildSidepanelRequestId = () =>
  `sidepanel_apps_${Date.now()}_${Math.random().toString(36).slice(2)}`;

export const postSidepanelMessage = (type, payload = {}) =>
  new Promise((resolve, reject) => {
    const requestId = buildSidepanelRequestId();
    const responseType = `${type}_RESPONSE`;
    const timeoutId = setTimeout(() => {
      window.removeEventListener("message", handleResponse);
      reject(new Error("No se detecto respuesta de la extension."));
    }, RESPONSE_TIMEOUT_MS);

    function handleResponse(event) {
      if (event.source !== window) return;
      if (event.origin !== window.location.origin) return;
      if (event.data?.type !== responseType) return;
      if (event.data?.requestId !== requestId) return;

      clearTimeout(timeoutId);
      window.removeEventListener("message", handleResponse);
      resolve(event.data.data);
    }

    window.addEventListener("message", handleResponse);
    window.postMessage({ type, requestId, ...payload }, window.location.origin);
  });

export const syncSidepanelAppsWithExtension = applications =>
  postSidepanelMessage("CRM_SIDEPANEL_SAVE_APPS", { applications });

export const openSidepanelApp = (app, context = {}) =>
  postSidepanelMessage("CRM_SIDEPANEL_OPEN_APP", {
    app,
    context: {
      source: "crm",
      openedAt: new Date().toISOString(),
      ...context
    }
  });

export const updateSidepanelContext = (context = {}) =>
  postSidepanelMessage("CRM_SIDEPANEL_UPDATE_CONTEXT", {
    context: {
      source: "crm",
      updatedAt: new Date().toISOString(),
      ...context
    }
  });
